export default __webpack_public_path__ + "static/media/Group25.d6a28f80.png";